<template>
  <ServicePageLayout
    title="Machine"
    subtitle="ระบบสถานะเครื่องจักร"
    icon="mdi-hvac"
    breadcrumb="Assets"
    :available="assets.length > 0"
  >
    <v-row v-if="assets.length > 0">
      <v-col cols="12" md="4" v-for="(item, index) in assets" :key="index">
        <MachineStatusWidget
          :device="item"
          :detail="item.assetName"
          :content="item.assetType"
          :timestamp="item.heartbeat"
          :image="item.icon"
          :status="item.data"
        />
      </v-col>
    </v-row>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import MachineStatusWidget from '@/components/machine/MachineStatusWidget'

export default {
  name: 'MachineView',
  components: {
    ServicePageLayout,
    MachineStatusWidget
  },
  computed: {
    assets: {
      get() {
        return this.$store.state.Asset.assetMachine
      },
    },
  },
}
</script>
